import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
  Box,
} from "@mui/material";
import deletemodel from "../../../assets/deletemodel.svg"
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import CustomPasswordInput from "../../../components/PasswordInput";
import { useTranslation } from "react-i18next";

const DeleteSettingsModal = ({ open, loading = false, onConfirm, onClose }) => {
  const [password, setPassword] = useState("");
  const [deletionReason, setDeletionReason] = useState("");
  const [errors, setErrors] = useState({});

  const { t } = useTranslation();

  const handleClose = () => {
    if (!loading) {
      setPassword("");
      setDeletionReason("");
      setErrors({});
      onClose?.();
    }
  };

  const handleConfirm = () => {
    const newErrors = {};
    if (!password.trim()) {
      newErrors.password = t("deleteSettingsModal.passwordRequired");
    }
    if (!deletionReason.trim()) {
      newErrors.deletionReason = t("deleteSettingsModal.reasonRequired")
;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onConfirm?.(password, deletionReason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      keepMounted
      disableEscapeKeyDown={loading}
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: "center",
          p: 2,
          py:1,
        },
      }}
      BackdropProps={{
        sx: { backdropFilter: "blur(1px)" },
      }}
    >
      <DialogContent sx={{ pt: 3 }}>
        {/* Top icon */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
          <img
            src={deletemodel}
            alt="delete"
            style={{ width: 50, height: 50 }}
          />
        </Box>

        {/* Message */}
        <CustomText sx={{ ...textStyles.h1, fontSize:18, fontWeight: 500,lineHeight:"32px" ,color: "#2C384C", mb: 3 }}>
   {t("deleteSettingsModal.title")}
          <br/>
       {t("deleteSettingsModal.subtitle")}
        </CustomText>

        {/* Password Input */}
        <Box sx={{ textAlign: "left", mb: 2 }}>
          <label style={{ fontSize: "14px", color: "#44546F", fontWeight: 500, marginBottom: "8px", display: "block" }}>
          {t("deleteSettingsModal.passwordLabel")}<span style={{ color: "red" }}>*</span>
          </label>
          <CustomPasswordInput
            placeholder={t("deleteSettingsModal.passwordPlaceholder")}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (errors.password) setErrors({ ...errors, password: "" });
            }}
            error={errors.password}
          />
          {errors.password && (
            <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
              {errors.password}
            </span>
          )}
        </Box>

        {/* Deletion Reason Input */}
        <Box sx={{ textAlign: "left", mb: 2 }}>
          <label style={{ fontSize: "14px", color: "#44546F", fontWeight: 500, marginBottom: "8px", display: "block" }}>
            {t("deleteSettingsModal.reasonLabel")}
            <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            className="project_input"
            placeholder={t("deleteSettingsModal.reasonPlaceholder")}
            value={deletionReason}
            onChange={(e) => {
              setDeletionReason(e.target.value);
              if (errors.deletionReason) setErrors({ ...errors, deletionReason: "" });
            }}
            style={{
              width: "100%",
              height: "90px",
              resize: "vertical",
            }}
          />
          {errors.deletionReason && (
            <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
              {errors.deletionReason}
            </span>
          )}
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 1.5,
          pb: 2.5,
          pt: 0,
        }}
      >
        {/* Cancel Button */}
        <CustomButton
          onClick={handleClose}
          disabled={loading}
          size="medium"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
             {t("logoutModel.cancel")}
            </Box>
          }
          sx={{color:"#172B4D",backgroundColor:"white",
              "&:hover": {
      backgroundColor: "white",  // same as normal
      color: "#172B4D",          // same as normal
    },
          }}
        />

        {/* Delete Button */}
        <CustomButton
          onClick={handleConfirm}
          disabled={loading}
          size="medium"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {loading && (
                <CircularProgress
                  size={18}
                  thickness={4}
                  sx={{ color: "#ffffff" }}
                />
              )}
              {t("logoutModel.deleteAccount") || "Delete Account"}
            </Box>
          }
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSettingsModal;